const routes = [
  {
    path: '/templates',
    redirect: { name: 'TemplateList' },
  },
  {
    path: '/templates',
    name: 'Templates',
    component: () => import('@/pages/Templates.vue'),
    meta: {
      pageTitle: 'Templates',
      requiresAuth: true,
      resourceName: 'COMMS-CONTEN',
    },
    children: [
      {
        path: '',
        name: 'TemplateList',
        component: () => import('./pages/TemplateList.vue'),
      },
      {
        path: 'edit/:id',
        name: 'TemplateEdit',
        component: () => import('./pages/TemplateEdit.vue'),
      },
      {
        path: 'new',
        name: 'TemplateNew',
        component: () => import('./pages/TemplateEdit.vue'),
      },
    ],
  },
]
export default routes
